<!-- Condensed step header: mobile/tablet only, appears once the page is scrolled -->
<div
  *ngIf="condensed"
  class="fixed inset-x-0 top-0 z-30 flex items-baseline justify-between border-b border-gray-200 bg-white/95 px-6 py-3 backdrop-blur lg:hidden"
>
  <span class="text-base font-bold text-gray-900">{{ activeLabel }}</span>
  <span class="text-xs font-semibold uppercase tracking-widest text-gray-400">Step {{ activeIndex + 1 }} of {{ steps.length }}</span>
</div>

<nav aria-label="Signup progress">
  <ol class="flex gap-3 sm:gap-5">
    <li *ngFor="let step of steps" class="flex-1">
      <button
        type="button"
        class="block w-full text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-700"
        [disabled]="step.state === 'inactive'"
        [attr.aria-current]="step.state === 'active' ? 'step' : null"
        (click)="goTo(step)"
      >
        <span
          class="block h-1 rounded-full"
          [ngClass]="{
            'bg-red-700': step.state === 'active',
            'bg-gray-900': step.state === 'complete',
            'bg-gray-200': step.state === 'inactive'
          }"
        ></span>
        <span
          class="mt-2.5 hidden text-xs font-semibold uppercase tracking-widest sm:block"
          [ngClass]="{
            'text-red-700': step.state === 'active',
            'text-gray-900': step.state === 'complete',
            'text-gray-400': step.state === 'inactive'
          }"
        >{{ step.label }}<span *ngIf="step.state === 'complete'" aria-hidden="true"> &#10003;</span></span>
      </button>
    </li>
  </ol>
  <p class="mt-3 text-xs font-bold uppercase tracking-widest text-red-700 sm:hidden">
    Step {{ activeIndex + 1 }} of {{ steps.length }} &middot; {{ activeLabel }}
  </p>
</nav>
